import { OAuthCallback } from '@/components/auth/oauth-callback';

export function OAuthPage() {
  return <OAuthCallback />;
}
